<div class="npdc-title">
  @if (case()) {
    <h1>Edit case - {{ case()?.title }}</h1>
  } @else {
    <h1>New case</h1>
  }

  <div class="npdc-title__actions">
    @if (form().pristine) {
      <a mat-flat-button type="button" routerLink="../">Close</a>
    } @else {
      <a mat-button type="button" routerLink="../">Close</a>
    }
  </div>
</div>

<form id="form" [formGroup]="form()" (ngSubmit)="save()">
  <p>
    <mat-form-field appearance="outline">
      <mat-label>Title</mat-label>
      <input matInput formControlName="title" />
    </mat-form-field>
  </p>

  <p>
    <mat-form-field appearance="outline">
      <mat-label>Date</mat-label>
      <input matInput formControlName="date" [matDatepicker]="picker" />
      <mat-hint>YYYY-MM-DD</mat-hint>
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
  </p>

  <p>
    <mat-form-field appearance="outline">
      <mat-label>Area</mat-label>
      <mat-select formControlName="area">
        <mat-option value="Antarktis">Antarktis</mat-option>
        <mat-option value="Arktis">Arktis</mat-option>
        <mat-option value="Bouvetøya">Bouvetøya</mat-option>
        <mat-option value="Dronning Maud Land">Dronning Maud Land</mat-option>
        <mat-option value="Jan Mayen">Jan Mayen</mat-option>
        <mat-option value="Peter I Øy">Peter I Øy</mat-option>
        <mat-option value="Svalbard">Svalbard</mat-option>
      </mat-select>
    </mat-form-field>
  </p>

  <p>
    <mat-form-field appearance="outline">
      <mat-label>Case number</mat-label>
      <input matInput formControlName="number" type="number" />
    </mat-form-field>
  </p>

  <p>
    <mat-form-field appearance="outline">
      <mat-label>Description</mat-label>
      <textarea formControlName="description" matInput rows="12"></textarea>
      <mat-hint
        >Keywords surrounded by [square brackets] will be replaced by links to placenames.</mat-hint
      >
    </mat-form-field>
  </p>

  <p>
    <mat-form-field appearance="outline">
      <mat-label>Comment</mat-label>
      <textarea
        formControlName="comment"
        matInput
        rows="3"
        cdkTextareaAutosize
        #autosize="cdkTextareaAutosize"
        cdkAutosizeMinRows="1"
        cdkAutosizeMaxRows="5"
      ></textarea>
    </mat-form-field>
  </p>

  <p class="npdc-form-actions">
    <button
      mat-flat-button
      type="submit"
      form="form"
      [disabled]="form().pristine || form().invalid"
    >
      Save
    </button>
  </p>
</form>
